export class HttpNoNetworkConnectionError extends Error {
  wasCaught = false;

  constructor() {
    super('No network connection');
  }
}
